module.exports = __webpack_public_path__ + "assets/img/7d49-pn.svg";